import React, {Component} from 'react';
import * as firebase from 'firebase';
import { Route, NavLink } from 'react-router-dom';
import ReactLoading from 'react-loading';
import Personal from './Personal';
import AuthorityDashbord from './AuthorityDashbord';
import EditPersonal from './EditPersonal';
import DetectionRecord from './DetectionRecord';
import HealthManagementTool from './HealthManagementTool'
import AuthorityPost from '../post/AuthorityPost';
import AuthorityDraftTable from '../post/AuthorityDraftTable';
import AuthorityPostTable from '../post/AuthorityPostTable';
import MailBox from '../post/MailBox';
import ReportBox from '../post/ReportBox';
import EditAuthorityPost from '../post/EditAuthorityPost';
import EditFaqPost from '../post/EditFaqPost';
import EditAuthorityDraft from '../post/EditAuthorityDraft';
import FAQ from '../View/FAQ';
import myFaqTable from '../post/myFaqTable';
import Login from '../View/Login';
import Fix from '../images/fix.svg';

import '../css/userProfile.css';


class MobileNav extends Component {
  constructor() {
    super();
    this.state = {
      showPost: false,
      showAuthority: false,
      showAdminPost: false,
      thePostDraftCount: false,
      theReportCount: false,
      showAuthorityPost: false
    }
    this.Logout = this.Logout.bind(this);
  }
  Logout() {
    firebase.auth().signOut().then(() => {
      window.location = ('/')
    })
  }
  componentDidMount() {
    window.scrollTo(0,0);
    setTimeout(() => this.setState({ loading: false }), 1500);
    firebase.auth().onAuthStateChanged((user) => {

      if(user) {
        var userId = firebase.auth().currentUser.uid;
        if(userId === '1CMe6HDAE6hZ0yzAAJvMz3yubok1' || userId === 'hZzPTCY7MNfOooscFxOAFRBjZeW2' || userId === 'PmVjFhPIScaOJGV5iNevoGReROE2' || userId === 'Rh7ph1zzqgdnCUR7YPM9YMPpG512') {
          const getReportCount = firebase.database().ref('reports/').orderByChild('repeatstate').equalTo('未處理');
          const getMailCount = firebase.database().ref('mailBox/').orderByChild('repeat').equalTo('未回覆');
          const transTotalCount = firebase.database().ref('users/').child(userId).child('totalCount');

          getReportCount.on('value', snap => {
            this.setState({
              theReportCount: snap.numChildren()
            })
            // console.log('錯誤回報: ' + this.state.theReportCount)
            transTotalCount.update({
              reportCount: this.state.theReportCount
            })
            transTotalCount.on('value', snap => {
              this.setState({
                reportCount: snap.val().reportCount
              })
            })
          })

          getMailCount.on('value', snap => {
            this.setState({
              theMailCount: snap.numChildren()
            })
            // console.log('mailBox: ' + this.state.theMailCount)
            transTotalCount.update({
              mailBoxCount: this.state.theMailCount
            })
            transTotalCount.on('value', snap => {
              this.setState({
                mailBoxCount: snap.val().mailBoxCount
              })
            })
          })
          this.setState({showAdminPost: true})
        }
        const getFaqCount = firebase.database().ref('faq/').orderByChild('userId').equalTo(userId);
        const faqtransTotalCount = firebase.database().ref('users/').child(userId).child('totalAuthorityCount');

        getFaqCount.on('value', snap => {
          this.setState({
            thFaqCount: snap.numChildren()
          })
          faqtransTotalCount.update({
            myFaqCount: this.state.thFaqCount
          })
          faqtransTotalCount.on('value', snap => {
            this.setState({
              myFaqCount: snap.val().myFaqCount
            })
          })
        })

        const getAuthorityPostDraftCount = firebase.database().ref('authorityPostsDraft/').orderByChild('userId').equalTo(userId);
        const transAuthorityTotalCount = firebase.database().ref('users/').child(userId).child('totalAuthorityCount');
        getAuthorityPostDraftCount.on('value', snap => {
          this.setState({
            thePotransAuthorityTotalCountstDraftCount: snap.numChildren()
          })
          transAuthorityTotalCount.update({
            postAuthorityDraftCount: this.state.thePotransAuthorityTotalCountstDraftCount
          })
          transAuthorityTotalCount.on('value', snap => {
            this.setState({
              postAuthorityDraftCount: snap.val().postAuthorityDraftCount
            })
          })
        })

        const checkWhatCanDoRef = firebase.database().ref('medicalTeam/').child(userId);
        checkWhatCanDoRef.update({
          userId: userId
        })
        checkWhatCanDoRef.on('value', snap => {
          this.setState({
            youCanDo: snap.val().youCanDo ? snap.val().youCanDo : null
          })
          if(this.state.youCanDo === 'yes') {
            this.setState({
              showAuthorityPost: true
            })
          }
        })
      } else {
        window.location = ('/')
      }
    })
  }
  render() {
    return(
      <div>
       <div style={Jeyu.mobilenavinfo} className="mobilenavinfo">
        <h2 style={Jeyu.title} className="mobileTitle">個人專區:</h2>
        <NavLink to="/UserProfile/Personal" activeClassName='active'>個人檔案</NavLink>
        <NavLink to="/UserProfile/EditPersonal" activeClassName='active'>修改個人檔案</NavLink>
        <NavLink to="/UserProfile/DetectionRecord" activeClassName='active'>體質分析檢測紀錄</NavLink>
        <NavLink to="/UserProfile/HealthManagementTool" activeClassName='active'>健康管理工具</NavLink>
        <h2 style={Jeyu.title} className="mobileTitle">互動專區:</h2>
          <NavLink to="/UserProfile/FAQ" activeClassName='active'>我想問問題</NavLink>
          <NavLink to="/UserProfile/myFaqTable" activeClassName='active' style={{position: 'relative'}} >我的發問
          <sup style={{display: this.state.myFaqCount ? 'block' : 'none', position:'absolute', top: '-5px', right: '-15px', color: '#fff', background:'#23C7C9', fontSize: 11, padding: '0 3px'}} >
              {this.state.myFaqCount}
            </sup>
          </NavLink>
          <div className="userProfileTitle">
          <h2 style={Jeyu.title} className="mobileTitle" >健康達人專區:</h2>
          <NavLink to="/UserProfile/AuthorityDashbord" activeClassName='active'>達人專欄</NavLink>
             <div style={{display: this.state.showAuthorityPost ? 'block' : 'none'}} className="mobileNav" >
             <NavLink to="/UserProfile/AuthorityPost" activeClassName='active'>新增文章</NavLink>
             <NavLink to="/UserProfile/AuthorityDraftTable" activeClassName='active' style={{position: 'relative'}}>管理草稿
              <sup style={{display: this.state.postAuthorityDraftCount ? 'block' : 'none', position:'absolute', top: '-5px', right: '-15px', color: '#fff', background:'#23C7C9', fontSize: 11, padding: '0 3px'}}>
               {this.state.postAuthorityDraftCount}
              </sup>
             </NavLink>
             <NavLink to="/UserProfile/AuthorityPostTable" activeClassName='active'>管理文章</NavLink>
            </div>
          </div> 
        <a onClick={this.Logout} style={Jeyu.logout}>登出</a>
       </div>
       <div style={Jeyu.lightbox} ></div>
      </div>
    )
  }
}

export default class UserProfile extends Component {
  constructor() {
    super();
    this.state = {
      showReply: false,
      loginloading: false,
      showAdminPost: false,
      loading: true,
      showAuthority: true,
      Authority: false,
      thePostDraftCount: false,
      theReportCount: false,
      postAuthorityDraftCount: false,
      showAuthorityPost: false,
      thePotransAuthorityTotalCountstDraftCount: false
    }
    this.Logout = this.Logout.bind(this);
    this.toggle = this.toggle.bind(this);
  }
  Logout() {
    firebase.auth().signOut().then(() => {
      window.location = ('/')
    })
  }
  toggle(e) {
    e.preventDefault()
    this.setState({showReply: !this.state.showReply})
  }
  componentDidMount() {
    window.scrollTo(0,0);
    setTimeout(() => this.setState({ loading: false }), 1500);
    firebase.auth().onAuthStateChanged((user) => {

      if(user) {
        var userId = firebase.auth().currentUser.uid;
        if(userId === '1CMe6HDAE6hZ0yzAAJvMz3yubok1' || userId === 'hZzPTCY7MNfOooscFxOAFRBjZeW2' || userId === 'PmVjFhPIScaOJGV5iNevoGReROE2' || userId === 'Rh7ph1zzqgdnCUR7YPM9YMPpG512') {
          const getReportCount = firebase.database().ref('reports/').orderByChild('repeatstate').equalTo('未處理');
          const getMailCount = firebase.database().ref('mailBox/').orderByChild('repeat').equalTo('未回覆');
          const transTotalCount = firebase.database().ref('users/').child(userId).child('totalCount');
          getReportCount.on('value', snap => {
            this.setState({
              theReportCount: snap.numChildren()
            })
            // console.log('錯誤回報: ' + this.state.theReportCount)
            transTotalCount.update({
              reportCount: this.state.theReportCount
            })
            transTotalCount.on('value', snap => {
              this.setState({
                reportCount: snap.val().reportCount
              })
            })
          })

          getMailCount.on('value', snap => {
            this.setState({
              theMailCount: snap.numChildren()
            })
            // console.log('mailBox: ' + this.state.theMailCount)
            transTotalCount.update({
              mailBoxCount: this.state.theMailCount
            })
            transTotalCount.on('value', snap => {
              this.setState({
                mailBoxCount: snap.val().mailBoxCount
              })
            })
          })

          this.setState({showAdminPost: true})
        }

        const getFaqCount = firebase.database().ref('faq/').orderByChild('userId').equalTo(userId);
        const faqtransTotalCount = firebase.database().ref('users/').child(userId).child('totalAuthorityCount');

        getFaqCount.on('value', snap => {
          this.setState({
            thFaqCount: snap.numChildren()
          })
          faqtransTotalCount.update({
            myFaqCount: this.state.thFaqCount
          })
          faqtransTotalCount.on('value', snap => {
            this.setState({
              myFaqCount: snap.val().myFaqCount
            })
          })
        })

        const getAuthorityPostDraftCount = firebase.database().ref('authorityPostsDraft/').orderByChild('userId').equalTo(userId);
        const transAuthorityTotalCount = firebase.database().ref('users/').child(userId).child('totalAuthorityCount');
        getAuthorityPostDraftCount.on('value', snap => {
          this.setState({
            thePotransAuthorityTotalCountstDraftCount: snap.numChildren()
          })
          transAuthorityTotalCount.update({
            postAuthorityDraftCount: this.state.thePotransAuthorityTotalCountstDraftCount
          })
          transAuthorityTotalCount.on('value', snap => {
            this.setState({
              postAuthorityDraftCount: snap.val().postAuthorityDraftCount
            })
          })
        })

        const checkWhatCanDoRef = firebase.database().ref('medicalTeam/').child(userId);
        checkWhatCanDoRef.update({
          userId: userId
        })
        checkWhatCanDoRef.on('value', snap => {
          this.setState({
            youCanDo: snap.val().youCanDo ? snap.val().youCanDo : null
          })
          if(this.state.youCanDo === 'yes') {
            this.setState({
              showAuthorityPost: true
            })
          }
        })

      } else {
        this.setState({ loginloading: true });
      }
    })
  }

  render() {
    const { loading } = this.state;
    const { loginloading } = this.state;
    if(loading) {
      return <ReactLoading type={"bubbles"} color={"#333"} style={Jeyu.loading} />
    }
    if(loginloading) {
      return <div style={{display: this.state.loginloading ? 'flex' : 'none', background: '#eeede9',justifyContent: 'center', alignItems:'center'}} >
        <Login />
      </div>
    }
    return(
      <div className="container hasPadding">
       <div className="row">
        <div className="col-xs-12 col-sm-3 col-md-3 col-lg-3">
         <div className="sidebarNav isActiveNav1" ref="checkSideBarNav">
          <h2 style={Jeyu.title}>個人專區:</h2>
          <NavLink to="/UserProfile/Personal" activeClassName='active'>個人檔案</NavLink>
          <NavLink to="/UserProfile/EditPersonal" activeClassName='active'>修改個人檔案</NavLink>
          <NavLink to="/UserProfile/DetectionRecord" activeClassName='active'>體質分析檢測紀錄</NavLink>
          <NavLink to="/UserProfile/HealthManagementTool" activeClassName='active'>健康管理工具</NavLink>
          <h2 style={Jeyu.title}>互動專區:</h2>
          <NavLink to="/UserProfile/FAQ" activeClassName='active'>我想問問題</NavLink>
          <NavLink to="/UserProfile/myFaqTable" activeClassName='active' style={{position: 'relative'}} >我的發問
          <sup style={{display: this.state.myFaqCount ? 'block' : 'none', position:'absolute', top: '-5px', right: '-15px', color: '#fff', background:'#23C7C9', fontSize: 11, padding: '0 3px'}} >
              {this.state.myFaqCount}
            </sup>
          </NavLink>
          <div style={{display: this.state.showAdminPost ? 'block' : 'none'}} >
           <h2 style={Jeyu.title} className="userProfileTitle" >系統專區:</h2>
           <NavLink to="/UserProfile/reportBox" activeClassName='active' style={{position: 'relative'}} >錯誤回報
            <sup style={{display: this.state.reportCount ? 'block' : 'none', position:'absolute', top: '-5px', right: '-15px', color: '#fff', background:'rgb(255, 70, 160)', fontSize: 11, padding: '0 3px'}}>
              {this.state.reportCount}
            </sup>
           </NavLink>
           <NavLink to="/UserProfile/MailBox" activeClassName='active' style={{position: 'relative'}} >MailBox
            <sup style={{display: this.state.mailBoxCount ? 'block' : 'none', position:'absolute', top: '-5px', right: '-15px', color: '#fff', background:'rgb(255, 70, 160)', fontSize: 11, padding: '0 3px'}}>
              {this.state.mailBoxCount}
            </sup>
           </NavLink>
          </div>
          <div className="userProfileTitle">
          <h2 style={Jeyu.title} className="mobileTitle" >健康達人專區:</h2>
          <NavLink to="/UserProfile/AuthorityDashbord" activeClassName='active'>達人專欄</NavLink>
             <div style={{display: this.state.showAuthorityPost ? 'block' : 'none'}} >
             <NavLink to="/UserProfile/AuthorityPost" activeClassName='active'>新增文章</NavLink>
             <NavLink to="/UserProfile/AuthorityDraftTable" activeClassName='active' style={{position: 'relative'}}>管理草稿
              <sup style={{display: this.state.postAuthorityDraftCount ? 'block' : 'none', position:'absolute', top: '-5px', right: '-15px', color: '#fff', background:'#23C7C9', fontSize: 11, padding: '0 3px'}}>
               {this.state.postAuthorityDraftCount}
              </sup>
             </NavLink>
             <NavLink to="/UserProfile/AuthorityPostTable" activeClassName='active'>管理文章</NavLink>
            </div>
          </div>
          <a onClick={this.Logout} style={Jeyu.logout}>登出</a>
         </div>

        </div>
        <div className="col-xs-12 col-sm-9 col-md-9 col-lg-9">
        <section className="isShowBox1" ref="checkBox">
         <Route exact path="/UserProfile/Personal" component={Personal} />
         <Route path="/UserProfile/AuthorityDashbord" component={AuthorityDashbord} />
         <Route path="/UserProfile/EditPersonal" component={EditPersonal} />
         <Route path="/UserProfile/DetectionRecord" component={DetectionRecord} />
         <Route path="/UserProfile/HealthManagementTool" component={HealthManagementTool} />
         <Route path="/UserProfile/AuthorityPost" component={AuthorityPost} />
         <Route path="/UserProfile/AuthorityPostTable" component={AuthorityPostTable} />
         <Route path="/UserProfile/AuthorityDraftTable" component={AuthorityDraftTable} />
         <Route path="/UserProfile/MailBox" component={MailBox} />
         <Route path="/UserProfile/ReportBox" component={ReportBox} />
         <Route path="/UserProfile/EditAuthorityPost/:id" component={EditAuthorityPost} />
         <Route path="/UserProfile/EditFaqPost/:id" component={EditFaqPost} />
         <Route path="/UserProfile/EditAuthorityDraft/:id" component={EditAuthorityDraft} />
         <Route path="/UserProfile/FAQ" component={FAQ} />
         <Route path="/UserProfile/myFaqTable" component={myFaqTable} />
        </section>
        </div>
        <div className="userProfileNavMobile">
           <a onClick={this.toggle} className='blockA' >
            <div style={Jeyu.mobilemenu}></div>
           </a>
           <div onClick={this.toggle} >
            {this.state.showReply && <MobileNav />}
           </div>
          </div>
       </div>
      </div>
    )
  }
}

const Jeyu = {
  Logo: {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center'
  },
  Nav: {
    display: 'flex',
    justifyContent: 'left',
    alignItems: 'center'
  },
  mobilemenu: {
   height: 25,
   width: 25,
   background: 'url('+Fix+') ',
   margin: '5px 0'
  },
  lightbox: {
   background: 'rgba(0,0,0,.8)',
   height: '100vh',
   position: 'fixed',
   width: '100%',
   zIndex: 9,
   left: 0,
   top: 0
  },
  mobilenavinfo: {
   margin: 0,
   padding: '0 27px',
   position: 'absolute',
   zIndex: 9999
 },
 userPhoto: {
  width: 45,
  height: 45,
  overflow: 'hidden',
  borderRadius: 77,
  display: 'inline-block'
 },
 loading: {
  margin: '20% auto',
  width: 77,
  height: '100vh'
},
 logout: {
   margin: 0,
   cursor: 'pointer',
   display: 'table'
 },
 title: {
   fontSize: 17,
   color: '#242424'
 }
 
}



// WEBPACK FOOTER //
// ./src/View/UserProfile.js